module.exports = __webpack_public_path__ + "static/media/pull-quote.19cbe8bf.png";